import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const download = (res: Blob, fileName: string): void => {
  if (res) {
    const blob = new Blob([res]);
    let url = (window.URL || window.webkitURL).createObjectURL(blob);
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();
    (window.URL || window.webkitURL).revokeObjectURL(url);
    a.remove();
  }
};

export const downloadPdf = async (element: any, pdfParams: PdfFileParams) => {
  try {
    var canvas = await html2canvas(element, { scale: 2 });
    let imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: 'letter',
      compress: true
    });

    let imageWidth = pdf.internal.pageSize.getWidth();
    let imageHeight = (canvas.height * imageWidth) / canvas.width;
    let pageHeight = pdf.internal.pageSize.getHeight();
    let notPrintedImageHight = imageHeight - pageHeight - 70;
    let position = -pageHeight + 70;

    pdf.setFont('times', 'bold');
    if (pdfParams.title) {
      pdf.text(pdfParams.title, 10, 20);
    }
    pdf.setFont('times', 'italic');
    if (pdfParams.headerName) {
      pdf.text(pdfParams.headerName, 10, 40);
    }

    pdf.addImage(imgData, 'PNG', 0, 65, imageWidth, imageHeight - 70, '', 'FAST');
    while (notPrintedImageHight >= 0) {
      pdf.addPage('letter', 'portrait');
      pdf.addImage(imgData, 'PNG', 0, position, imageWidth, imageHeight - 70, '', 'FAST');
      notPrintedImageHight -= pageHeight;
      position -= pageHeight;
    }
    pdf.save(`${pdfParams.fileName}.pdf`);
  } catch (error) {
    console.error('Error exporting PDF', error);
  }
};

export type PdfFileParams = {
  title?: string;
  headerName?: any;
  fileName: fileName;
};
type fileName = 'invoice' | 'report';
